import { type ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { MailtoLink } from 'MailtoLink';
import { type AcceptedPrimaryMessage } from '../applicationStatus.types';

/*
    Shown for accepted and pre-accepted users when there is no tuition and registration body.

    `failed_unfortunately` carries a <mail/> slot; the other keys in this family are plain text with
    <strong>, which <Trans> keeps by default. So one render covers every key.
*/
export function AcceptedMessage({ message }: { message: AcceptedPrimaryMessage }): ReactElement {
    const { t } = useTranslation('back_royal');

    return (
        <div className="text-center text-sm text-slate-grey">
            <Trans
                t={t}
                i18nKey={message.key}
                values={message.values}
                components={{ mail: <MailtoLink className="text-sm" email={message.brandEmail} /> }}
            />
        </div>
    );
}
